const dev = {
  apiGateway: {
    URL: "https://p4ecfvunhj.execute-api.eu-west-2.amazonaws.com/staging"
  },
};

const prod = {
  apiGateway: {
    URL: "https://invite-api.flatfair.co.uk"
  },
};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};


// WEBPACK FOOTER //
// ./src/config.js